import React from "react";
import ChangePassword from "../components/ChangePassword";
import Breadcrumb from "../components/Breadcrumb";
import MasterLayout from "../masterLayout/MasterLayout";

const ChangePasswordPage = () => {
  return (
        <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Change Password" />

        {/* DashBoardLayerTwo */}
      <ChangePassword />

      </MasterLayout>
    </>
  );
};

export default ChangePasswordPage;
